import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { NavigationContext, ConditionalContext } from './NavigationContext.js';
import { useId } from '../../utils/hooks/useId.js';

const bem = Bem.create("vai-navigation-menu");
const NavigationMenu = (props) => {
  const navigation = React.useContext(NavigationContext);
  const {
    children,
    className,
    menuKey,
    htmlId,
    dataTa,
    selectedKey = navigation.selectedKey,
    openSubmenuKeys = navigation.openSubmenuKeys,
    onSelectItem = navigation.onSelectItem,
    onSubmenuToggle = navigation.onSubmenuToggle,
    ...rest
  } = props;
  const id = useId(htmlId);
  const ref = React.useRef(null);
  return /* @__PURE__ */ React.createElement(ConditionalContext, {
    navigation,
    navigationProps: { selectedKey, openSubmenuKeys, onSelectItem, onSubmenuToggle }
  }, /* @__PURE__ */ React.createElement("ul", {
    className: addClass(bem.block(), "vai-navigation-context", className),
    role: "menu",
    id: id.toString(),
    ref,
    "data-ta": dataTa,
    ...rest
  }, children));
};

export { NavigationMenu };
